<template>
  <div class="app-cl-menu">
    <GfrMenuNav>
      <GfrMenuList>
        <GfrMenuItem v-for="(item, index) in menuList" :key="index">
          <GfrMenuLink
            class="app-cl-menu-link"
            :to="formatRoutePath(item.link)"
            :target="isNewTabOpen(item) ? '_blank' : '_self'"
            has-active-line
          >
            <span class="app-cl-menu-text truncate ...">{{ item.name }}</span>
            <IconsOutArrow v-if="isOutsideLink(item)" class="w-3.5 h-3.5 ml-1 mt-0.5" />
          </GfrMenuLink>
        </GfrMenuItem>
      </GfrMenuList>
    </GfrMenuNav>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue'
import type { ConfigApiMenu } from '@/server/types'
const store = useStore()
const { formatTransify } = store
const { config } = storeToRefs(store)
const menuList = computed(() => {
  const clMenu: ConfigApiMenu[] = [
    {
      id: 0,
      name: formatTransify('UGC_OFFICIAL_WEBSITE_SQUARE'),
      link: '/{lang}/craftland',
      is_new_tab: 0,
      is_outside_website: 0
    }
  ]
  const menu = deepClone(config.value.menu)
  const firstTutorial = findFirstPath(menu, '/{lang}/tutorial/cl')
  const firstDocument = findFirstPath(menu, '/{lang}/docs')
  if (firstTutorial) {
    firstTutorial.name = formatTransify('UGC_OFFICIAL_WEBSITE_TUTORIAL')
    firstTutorial.link = firstTutorial.link.replace('{lang}', '{lang}/craftland')
    clMenu.push(firstTutorial)
  }
  if (firstDocument) {
    firstDocument.name = formatTransify('UGC_OFFICIAL_WEBSITE_DOCUMENTS')
    firstDocument.link = firstDocument.link.replace('{lang}', '{lang}/craftland')
    clMenu.push(firstDocument)
  }
  return clMenu
})
const route = useRoute()
function formatRoutePath(link: string) {
  return link.replace('{lang}', route.params.lang as string)
}
function isOutsideLink(item: ConfigApiMenu) {
  return item.is_outside_website === 1
}
function isNewTabOpen(item: ConfigApiMenu) {
  return item.is_new_tab === 1
}
/* --- 找到符合条件的MenuItem --- */
function findFirstPath(menu: ConfigApiMenu[], key: string): ConfigApiMenu | undefined {
  for (const item of menu) {
    if (item.link.includes(key)) {
      return item
    }
    if (item.children) {
      const found = findFirstPath(item.children, key)
      if (found) {
        return found
      }
    }
  }
  return undefined
}
</script>
<style lang="postcss" scoped>
.app-cl-menu {
  @apply w-full h-full flex items-center;
}
.app-cl-menu-link {
  @apply text-2xl after:-bottom-3 uppercase;
}
.app-cl-menu-text {
  @apply max-w-64 overflow-hidden;
}
</style>
